import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpErrorResponse,
	HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ServerAlertDialogComponent } from '../../modules/auth/server-alert-dialog/server-alert-dialog.component';
import { AuthenticationsService } from '../../modules/authentications/authentications.service';
import { SnackBarService } from '../../shared/components/snack-bar/snack-bar.service';
import { RouteUtils } from '../../shared/utils/route/route.util';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	bypassUrl: string[] = ['viacep.com.br', 'servicodados.ibge.gov.br'];

	constructor(
		private readonly authenticationsService: AuthenticationsService,
		private readonly dialog: MatDialog,
		private readonly router: Router,
		private readonly snackbarService: SnackBarService,
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((e: HttpErrorResponse) => {
				// TODO remove error handling from Services and Effects

				// TODO Remove after applying to all. Applied:
				//      - Login Error Messages
				//      - Download XLS File (Beneficiaries Registration)
				if (request.url.split('/')[5] === 'login') {
					if (!e.status || e.status === 0 || e.status >= 500) {
						this.dialog.open(ServerAlertDialogComponent);
					}

					if (
						e.status >= HttpStatusCode.BadRequest &&
						e.status < HttpStatusCode.InternalServerError
					) {
						this.snackbarService.showSnack(e.error?.message, 'error');
					}
				}

				if (
					e.status === HttpStatusCode.Unauthorized &&
					!ErrorInterceptor.isZohoIntegrationRequest(request)
				) {
					this.authenticationsService.resetToken();
					this.router.navigateByUrl(RouteUtils.paths.auth.login);
					this.snackbarService.showSnack(e.error?.message, 'error');
				}

				if (
					request.url.split('/')[1].split('.')[0] === 'sanusuploadcargaplanilha'
				) {
					this.dialog.open(ServerAlertDialogComponent, {
						data: {
							message: [
								'Ocorreu um erro no carregamento deste arquivo, tente novamente mais tarde.',
								'Caso o erro persista, informe ao suporte técnico.',
							],
						},
					});
				}

				return throwError(e);
			}),
		);
	}

	private static isZohoIntegrationRequest(
		request: HttpRequest<unknown>,
	): boolean {
		return request.url.includes('/api/integrations/zoho/');
	}
}
